import {utilHelper} from "../../_helpers";
import {SUCCESSFUL_TRANSLATION_LABEL} from "../../../components/i18n/i18n";

const relativeUrl = 'api/harbor'

export const harborService = {
	search,
	getItem,
	saveItem,
	updateItem,
	deleteItem,
	translate,
};

function search(offset, max, data) {
	return utilHelper.doRequestHandleResponse(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', { data: data, showAlert:false })
}

function getItem(id) {
	return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

function saveItem(data) {
	return utilHelper.doRequestHandleResponse(`${relativeUrl}`, 'POST', { data: data });
}

function updateItem(id, data) {
	return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}`, 'PUT', { data: data });
}

function deleteItem(id, fbDB) {
	return utilHelper.doRequestHandleResponse(`${relativeUrl}/${id}/${fbDB}`, 'DELETE',{});
}

function translate(id, data){
	return utilHelper.doRequestHandleResponse(`${relativeUrl}/translate/${id}`, 'POST', { data: data, message:SUCCESSFUL_TRANSLATION_LABEL });
}